<template>
  <div class="transactionMode-page">
    <el-tabs v-model="goodsTypeTab" @tab-click="goodsTypeTabHandleClick">
      <el-tab-pane label="当期网络零售额" name="currentSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('city')">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.startTime" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" @change="getWholeList(wholeTime = 2)"
                                class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <chart ref="chart1" :options="transactionModeOptions" autoresize class="width-z100 margin-t-30"></chart>
          <el-table :data="transactionModeTable" stripe height="340" class="float-left border-DEDEDE margin-t-30 margin-b-20">
            <el-table-column prop="month" label="时间" align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value" label="B2C网络零售额（万元）" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value" label="C2C网络零售额（万元）" align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value_yoy" label="B2C同比（%）" width="158" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value_yoy" label="C2C同比（%）" align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value_pro" label="B2C占比（%）" width="158" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value_pro" label="C2C占比（%）" align="center"></el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="累计网络零售额" name="cumulativeSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('city')">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.startTime" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" @change="getWholeList(wholeTime = 2)"
                                class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-20">
          <chart ref="chart1" :options="transactionModeOptions" autoresize class="width-z100 margin-t-30"></chart>
          <el-table :data="transactionModeTable" stripe height="340" class="float-left border-DEDEDE margin-t-30 margin-b-20">
            <el-table-column prop="month" label="时间" align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value" label="B2C网络零售额（万元）" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value" label="C2C网络零售额（万元）" align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value_yoy" label="B2C同比（%）" width="158" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value_yoy" label="C2C同比（%）" align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value_pro" label="B2C占比（%）" width="158" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value_pro" label="C2C占比（%）" align="center"></el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>
    </el-tabs>
    <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">注：<BR/>
      1.B2C是指企业（包括企业、个体工商户、农民专业合作社等）通过网络零售平台面向个人销售产品或服务的交易模式，C2C是指个人通过网络零售平台面向个人销售产品或服务交易模式；
      2.按照店铺经营模式划分，将个人店铺划分为C2C店铺，企业店铺划分为B2C店铺。</p>
  </div>
</template>

<script>
  export default {
    name: 'transactionMode',
    data () {
      return {
        goodsTypeTab: 'currentSales',
        chooseType: '当期网络零售额',//当前选择查询条件
        transactionModeOptions: {}, //交易模式网络零售额图表
        transactionModeTable: [],//交易模式网络零售额表格

        currentSalesForm: {startTime: '', endTime: ''},//当期网络零售额筛选条件
        wholeTime: '1',

        //表格数据

        productTwoTable: [],
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }
    },
    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      this.twelveMonth()
      // this.oneMonth()
    },
    methods: {
      dateChangebirthday (val) {
        this.wholeTime = 2
        this.currentSalesForm.value1 = val
      },
      goodsTypeTabHandleClick (tab, event) {
        if (tab.name == 'cumulativeSales') {
          this.chooseType = '累计网络零售额'
          this.getWholeList()
        }
        if (tab.name == 'currentSales') {
          this.chooseType = '当期网络零售额'
          this.getWholeList()
        }

      },
      //交易模式
      getWholeList () {
        this.$http.get(this.header + '/qyjc/jyms', {
          params: {
            index_type: this.chooseType,
            sMonth: this.currentSalesForm.startTime,
            eMonth: this.currentSalesForm.endTime
          }
        }).then(res => {
          if (res.data.code == 0) {
            let wholeList = {xTime: [], yb2cMoney: [],yc2cMoney:[],b2cYoy:[],c2cYoy:[]}

            //交易模式图表
            res.data.list.reverse().forEach((y, index) => {
              wholeList.xTime.push(y.times)
              let yb2c = {
                value: y.s_absoulte_value_pro,
                unit: '%'
              }
              let yc2c = {
                value: y.f_absoulte_value_pro,
                unit: '%'
              }
              let yb2cYoy = {
                value: y.s_absoulte_value_yoy,
                unit: '%'
              }
              let yc2cYoy = {
                value: y.f_absoulte_value_yoy,
                unit: '%'
              }
              wholeList.yb2cMoney.push(yb2c)
              wholeList.yc2cMoney.push(yc2c)
              wholeList.b2cYoy.push(yb2cYoy)
              wholeList.c2cYoy.push(yc2cYoy)
            })
            this.transactionModeTable = res.data.list.reverse()
            let Min1 = this.calMin(wholeList.b2cYoy), Min2 = this.calMin(wholeList.c2cYoy),
              Max1 = this.calMax(wholeList.b2cYoy), Max2 = this.calMax(wholeList.c2cYoy)
            //交易模式图表
            this.transactionModeOptions = {
              title: {//图表标题
                text: '各交易模式' + this.chooseType + '变化趋势',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300
                },
              },
              toolbox: { //图表工具箱
                feature: {
                  magicType: {show: false, type: ['line', 'bar']},
                  restore: {show: false},
                  saveAsImage: {show: true}
                }
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                  type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
              },
              legend: {//图表说明  horizontal竖着显示vertical横显示
                orient: 'horizontal',
                y: 'bottom',
                // x: 'left',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: ['B2C占比', 'C2C占比','B2C同比','C2C同比']
              },
              xAxis: {
                type: 'category',
                data: wholeList.xTime,

                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                }
              },
              yAxis: [
                {
                  type: 'value',
                  name: '%',
                  min: 0,
                  max: 100,
                  // splitNumber: 5,
                  // interval: (Max1 - Min1) / 5,
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                },{
                  type: 'value',
                  name: '%',
                  // min: Min1,
                  // max: Max1,
                  // splitNumber: 5,
                  // interval: (Max1 - Min1) / 5,
                  // axisLabel: {
                  //   formatter: '{value} %'
                  // },
                  splitLine:{//去除网格线
                    show:false
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                }],
              series: [{
                name: 'B2C占比',
                type: 'bar',
                stack: '总量',
                barCategoryGap: '60%',
                itemStyle: {
                  normal: {
                    color: '#7888ed'
                  }
                },
                data:wholeList.yb2cMoney,
                smooth: true
              }, {
                name: 'C2C占比',
                type: 'bar',
                stack: '总量',
                itemStyle: {
                  normal: {
                    color: '#66c6db'
                  }
                },
                data: wholeList.yc2cMoney
              }, {
                name: 'B2C同比',
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                  normal: {
                    color: '#649CEE'
                  }
                },
                data: wholeList.b2cYoy
              }, {
                name: 'C2C同比',
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                  normal: {
                    color: '#EB7D6F'
                  }
                },
                data: wholeList.c2cYoy
              }]
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //选择近13个月
      twelveMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 15; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        this.wholeTime = '1'
        if (day > 14) {
          this.currentSalesForm.startTime = dataArr[13]
          this.currentSalesForm.endTime = dataArr[1]
        } else {
          this.currentSalesForm.startTime = dataArr[14]
          this.currentSalesForm.endTime = dataArr[2]
        }
        this.getWholeList()

      },
      //计算最大值
      calMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxInt = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxVal = maxInt * 10//让显示的刻度是整数
        return maxVal
      },

      //计算最小值
      calMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minInt = Math.floor(min / 10)
        let minVal = minInt * 10//让显示的刻度是整数
        return minVal
      },

    }
  }
</script>

<style>

  .transactionMode-page {}

  .transactionMode-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
    /*color: #CED4DF;*/
  }

  .transactionMode-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .transactionMode-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0px;
  }

  .transactionMode-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .transactionMode-page .el-form-item {
    margin-bottom: 0;
  }

  .transactionMode-page .el-radio, .transactionMode-page .el-form-item__label {
    color: #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/area/transactionMode.vue